import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ROLES } from '../../firebase.marketplace';

// Streaming components
import StreamingEvents from './StreamingEvents';
import EventDetails from './EventDetails';
import MyTickets from './MyTickets';
import CreateEventForm from './CreateEventForm';
import EditEventForm from './EditEventForm';
import EventManagementDashboard from './EventManagementDashboard';
import TicketVerification from './TicketVerification';

// Auth components
import ProtectedRoute from '../auth/ProtectedRoute';

// Layout component
import StreamingLayout from './StreamingLayout';

const StreamingEventsRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={
        <StreamingLayout>
          <StreamingEvents />
        </StreamingLayout>
      } />
      
      <Route path="/:id" element={
        <StreamingLayout>
          <EventDetails />
        </StreamingLayout>
      } />
      
      {/* Protected Routes */}
      <Route path="/my-tickets" element={
        <ProtectedRoute>
          <StreamingLayout>
            <MyTickets />
          </StreamingLayout>
        </ProtectedRoute>
      } />
      
      {/* Artist Routes */}
      <Route path="/create-event" element={
        <ProtectedRoute requiredRole={ROLES.ARTIST}>
          <StreamingLayout>
            <CreateEventForm />
          </StreamingLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/manage-events" element={
        <ProtectedRoute requiredRole={ROLES.ARTIST}>
          <StreamingLayout>
            <EventManagementDashboard />
          </StreamingLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/edit-event/:id" element={
        <ProtectedRoute requiredRole={ROLES.ARTIST}>
          <StreamingLayout>
            <EditEventForm />
          </StreamingLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/verify-tickets" element={
        <ProtectedRoute requiredRole={ROLES.ARTIST}>
          <StreamingLayout>
            <TicketVerification />
          </StreamingLayout>
        </ProtectedRoute>
      } />
    </Routes>
  );
};

export default StreamingEventsRoutes;
